import React from 'react';

/**
 * Bold, high-contrast treatment for project names (cards, headers, table cells).
 */
const ProjectNameText = ({
  children,
  as: Tag = 'span',
  className = '',
  ...rest
}) => {
  const combined = ['project-name-highlight', className].filter(Boolean).join(' ');
  if (children == null || children === '') {
    return (
      <Tag className={combined} {...rest}>
        —
      </Tag>
    );
  }
  return (
    <Tag className={combined} {...rest}>
      {children}
    </Tag>
  );
};

export default ProjectNameText;
